import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate' // 对vuex数据持久化存储，避免独立操作loaclstorege
import Store from '@/finiteComponents/Layout/LeftNav/store'
import { StateType } from './StoreTypes'
const state: StateType = {
  production: process.env.NODE_ENV === 'production',
  is3Part: false,
  user: {
    token: '',
    info: null,
    orgid: null,
  },
  detectStatus: 0, // 0-未注销，1-注销中
  detectDeadline: '', // 注销截止日期
  showDetectAccountModal: false,
  showConfirmDetectModal: false,
  lang: 'zh', // zh中文
  configTiny: {
    // 用户管理项目
    userAuth: {},
  },
  services: {
    userApi: 'user-api',
    bizApi: 'biz-api',
    scrm_sys_api: 'kb-sys-api',  //测试环境
    // scrm_sys_api: 'scrm-sys-api',  //开发环境
    // scrm_sys_api:
    //   ['localhost', 'robot.guiji.ai', '172.16.103.12'].indexOf(location.hostname) >= 0
    //     ? 'scrm-sys-api'
    //     : 'kb-sys-api', //开发环境
    fee_api: 'fee-api',
    digitalApi: 'digital-api',
    messageApi: 'message-api',
    isvApi: 'isv-api',
    configServer: 'config-server',
  },
  // tabs菜单数组
  tabsArr: [
    // 首页
    // {
    //   key: 'home',  // 唯一标识
    //   name: '首页', // tab的名称
    //   url: '/homePage', // tab的路径
    //   parentKey: '', // tab的父节点key（可有可无）
    //   isOutside: '', // 是否是子系统之间跳转而打开的tab页，如果是需要做特殊的菜单联动处理（可有可无）
    //   child: [], // 是否有子节点（可有可无）
    // },
  ],
  // 当前高亮的tab页
  activeTabName: '',
  // 第一版菜单是前端写死，并且一级二级菜单还分开存储了，后续配合后端优化，暂时这样写
  menus: [], // 一级菜单
  subMenus: [], // 二级菜单
  selectSubmenus: [], // 当前选中的一级菜单对应的二级菜单
  selectMenu: {}, // 当前选中的一级菜单
  leftMenuCollapse: true, // 左侧二级菜单是否收起展开
  guideChange: '', //触发菜单开启
  currentMicroDom: '', // 当前微应用渲染的dom对象
  langPackage: {}, // 语言包
  systemMessage: { message: {}, unReadCount: 0, announcement: {} }, // 系统消息
  checkedMessageId: undefined, // 查看消息的 id
  checkedBroadcastId: undefined, // 查看广播消息的 id
  checkedNoticeMessageId: undefined, // 查看公告消息的 id
  config: {}, // 配置信息
}

const InitState = JSON.parse(JSON.stringify(state)) // 保存初始数据
const mutations = {
  set_data(state: StateType, data: StateType) {
    for (const key in data) {
      // console.log(typeof data[key])
      if (Array.isArray(data[key])) {
        state[key] = data[key]
      } else if (typeof data[key] === 'object') {
        state[key] = { ...state[key], ...data[key] } // 保证差异更新
      } else {
        state[key] = data[key]
      }
    }
  },
  // vuex清除数据
  clear_data(state: StateType) {
    const localBrowserUniqueCode = localStorage.getItem('browserUniqueCode')
    const localListen = localStorage.getItem('localListen') || ''
    const voiceListen = localStorage.getItem('voiceListen') || ''
    const newWelfare = localStorage.getItem('newWelfare') || ''
    const isNoTrainTips = localStorage.getItem('isNoTrainTips') || ''
    const language = localStorage.getItem('lang') || ''
    localStorage.clear()
    if (localBrowserUniqueCode) {
      localStorage.setItem('browserUniqueCode', localBrowserUniqueCode)
    }
    sessionStorage.clear()
    localStorage.setItem('isIntro', JSON.stringify({ nextGuideName: '', state: 0 }))
    localStorage.setItem('newWelfare', newWelfare)
    localStorage.setItem('localListen', localListen)
    localStorage.setItem('voiceListen', voiceListen)
    localStorage.setItem('isNoTrainTips', isNoTrainTips)
    localStorage.setItem('lang', language)
    Store.store.defaultActive = ''
    const stateArr = Object.keys(state)
    stateArr.forEach((key) => {
      state[key] = InitState[key]
    })
  },
}

const actions = {}

export default createStore({
  state,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      key: '__user',
      storage: {
        getItem: (key) => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: (key) => sessionStorage.removeItem(key),
      },
    }),
  ],
})
